import { markIntentionalLogout } from './authSessionFlags';

export const LOGOUT_REDIRECT_PATH = '/login';

export async function signOutAndRedirectToLogin({
  auth,
  signOutFn,
  replaceLocation = (path) => window.location.replace(path),
  onError = console.error,
}) {
  try {
    // Mark this as a deliberate sign-out so AuthContext does NOT treat the
    // resulting null-user transition as an expired session (which would show
    // the "session expired" notice on /login).
    markIntentionalLogout();
    await signOutFn(auth);
    replaceLocation(LOGOUT_REDIRECT_PATH);
  } catch (error) {
    onError('Error signing out:', error);
  }
}
